import { BlockList, PlacementProvider } from '@zillow/cms-blocks';
import { Box, Heading } from '@zillow/constellation';
import React from 'react';

import { SidebarWrapper } from '../B2CPostTemplate';
import FooterTemplate from '../FooterTemplate/FooterTemplate';

import { B2BPostTemplateProps } from './B2BPostTemplate.types';
import PostByLine from './PostByLine';
import PostCategories from './PostCategories';
import PostFeaturedImage from './PostFeaturedImage';

const B2BPostTemplate: React.FC<B2BPostTemplateProps> = ({
    post: {
        title: { raw: title },
        sidebar,
        footer,
        categories,
        primaryCategory,
        author,
        readTime,
        date,
        featuredImage,
    },
    post,
    stickySidebarTop,
}) => {
    return (
        <>
            <Box
                sx={{
                    maxWidth: '$breakpoints.xl',
                    margin: '$spacing.lg auto',
                    padding: '0 $spacing.sm',
                }}
            >
                <Box
                    sx={{
                        '@media $lg': {
                            display: 'flex',
                        },
                    }}
                >
                    <Box
                        sx={{
                            flex: '1 1 0',
                            minWidth: 0,
                        }}
                    >
                        <PostCategories
                            categories={categories}
                            primaryCategory={primaryCategory}
                        />

                        <Heading
                            level={1}
                            fontType={{
                                default: 'h4',
                                lg: 'h3',
                            }}
                            fontFamily="serif"
                            marginBottom="sm"
                        >
                            {title}
                        </Heading>

                        {featuredImage && (
                            <PostFeaturedImage
                                featuredImage={featuredImage}
                                defaultAlt={title}
                            />
                        )}

                        <PostByLine
                            author={author}
                            readTime={readTime}
                            date={date}
                        />

                        <Box sx={{ marginBottom: '$spacing.lg' }}>
                            <PlacementProvider placement="post">
                                <BlockList blocks={post.blocks || []} />
                            </PlacementProvider>
                        </Box>
                    </Box>

                    {sidebar && (
                        <Box
                            sx={{
                                marginTop: '$spacing.xl',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '300px',
                                '@media $md_lte': {
                                    width: '100%',
                                    marginTop: 0,
                                },
                                '@media $lg': {
                                    marginLeft: '$spacing.xl',
                                    marginRight: 0,
                                    marginTop: 0,
                                },
                            }}
                        >
                            <SidebarWrapper sticky top={stickySidebarTop}>
                                <BlockList blocks={sidebar?.blocks || []} />
                            </SidebarWrapper>
                        </Box>
                    )}
                </Box>
            </Box>
            {footer && <FooterTemplate footer={footer} />}
        </>
    );
};

export default B2BPostTemplate;
